import React from 'react';
import MyAccountCard from './MyAccountCard';

interface MyAccountPageShellProps {
    id?: string;
    slug?: string;
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
    meta?: React.ReactNode;
    actions?: React.ReactNode;
    eyebrow?: React.ReactNode;
    children: React.ReactNode;
    className?: string;
    panelClassName?: string;
    bodyClassName?: string;
    contentClassName?: string;
    headerClassName?: string;
    titleAs?: React.ElementType;
}

const joinClassNames = (...values: Array<string | false | null | undefined>): string =>
    values.filter(Boolean).join(' ');

const MyAccountPageShell: React.FC<MyAccountPageShellProps> = ({
    id,
    slug,
    title,
    subtitle,
    meta,
    actions,
    eyebrow,
    children,
    className = '',
    panelClassName = '',
    bodyClassName = '',
    contentClassName = '',
    headerClassName = '',
    titleAs: TitleTag = 'h2',
}) => {
    const resolvedSlug = slug || (typeof title === 'string' && title.trim() !== '' ? title : 'page');

    return (
        <div id={id} className={joinClassNames('weka-my-account-page', className)}>
            <MyAccountCard
                variant="page"
                slug={resolvedSlug}
                title={title}
                subtitle={subtitle}
                meta={meta}
                actions={actions}
                eyebrow={eyebrow}
                className={panelClassName}
                innerClassName={bodyClassName}
                contentClassName={contentClassName}
                headerClassName={headerClassName}
                titleAs={TitleTag}
            >
                {children}
            </MyAccountCard>
        </div>
    );
};

export default MyAccountPageShell;
